import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Center, Loader, Text, Stack } from '@mantine/core';
import { useAuth } from '../contexts/AuthContext';

const AutoLoginSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser, setUserType } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const userParam = searchParams.get('user');

    if (token && userParam) {
      try {
        // Decode user data
        const userData = JSON.parse(atob(userParam));

        // Store in localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('userType', 'member');

        // Update auth context
        console.log('userData: ', userData);
        setUser(userData);
        setUserType('member');

        // Redirect to dashboard
        navigate('/member/dashboard', { replace: true });
      } catch (error) {
        console.error('Auto-login failed:', error);
        ///navigate('/member/login?error=login_failed', { replace: true });
      }
    } else {
      navigate('/member/login?error=missing_data', { replace: true });
    }
  }, [searchParams, navigate, setUser, setUserType]);

  return (
    <Center h="100vh">
      <Stack align="center">
        <Loader size="lg" />
        <Text>Logging you in...</Text>
        <Text size="sm" c="dimmed">Please wait while we authenticate you</Text>
      </Stack>
    </Center>
  );
};

export default AutoLoginSuccess;